module.exports = __webpack_public_path__ + "static/img/alps_empty_wifi.9582ae79.webp";